module.exports = __webpack_public_path__ + "img/item-top-inactive.5289db87.png";